import React from 'react';
import { motion, type HTMLMotionProps } from 'framer-motion';

export interface GradientCardProps extends HTMLMotionProps<'div'> {
  children: React.ReactNode;
  className?: string;
  gradientTheme?: 'gold' | 'cyan' | 'purple' | 'multicolor';
}

export const GradientCard: React.FC<GradientCardProps> = ({
  children,
  className = '',
  gradientTheme = 'multicolor',
  ...motionProps
}) => {
  const borderGradientMap = {
    gold: 'from-amber-400 via-yellow-200 to-amber-600',
    cyan: 'from-cyan-400 via-sky-300 to-indigo-500',
    purple: 'from-fuchsia-500 via-purple-400 to-indigo-600',
    multicolor: 'from-amber-400 via-fuchsia-500 to-cyan-400',
  };

  return (
    <motion.div
      className={`relative p-[1.5px] rounded-3xl overflow-hidden group ${className}`}
      {...motionProps}
    >
      {/* Radiant Glowing Border */}
      <div
        className={`absolute inset-0 bg-gradient-to-r ${borderGradientMap[gradientTheme]} opacity-70 group-hover:opacity-100 transition-opacity blur-[1px]`}
      />

      {/* Inner Deep Translucent Surface */}
      <div className="relative w-full h-full bg-midnight-950/90 backdrop-blur-2xl rounded-[calc(1.5rem-1.5px)] p-5 sm:p-6">
        {children}
      </div>
    </motion.div>
  );
};
